/**
 * assets/main-categories.js
 * Slider logic for “Main Categories” section.
 * Requires: deferred inclusion in theme.liquid:
 *   <script src="{{ 'main-categories.js' | asset_url }}" defer></script>
 */

(function() {
  /**
   * Initialize one slider instance scoped to its section element
   * @param {HTMLElement} sectionEl
   */
  function initMainCategoriesSlider(sectionEl) {
    const sliderContainer       = sectionEl.querySelector('.top-collage-slider');
    const prevButton            = sectionEl.querySelector('.top-slider-arrow.prev');
    const nextButton            = sectionEl.querySelector('.top-slider-arrow.next');
    const radioIndicatorContainer = sectionEl.querySelector('.top-radio-indicators');

    if (!sliderContainer || !prevButton || !nextButton || !radioIndicatorContainer) {
      return;
    }

    // Build the little dots under the slider
    function createDots() {
      radioIndicatorContainer.innerHTML = '';
      const containerWidth = sliderContainer.clientWidth;
      const totalScroll   = sliderContainer.scrollWidth - containerWidth;
      const numberOfDots  = totalScroll > 0
        ? Math.ceil(totalScroll / containerWidth) + 1
        : 1;

      for (let i = 0; i < numberOfDots; i++) {
        const label     = document.createElement('label');
        label.classList.add('top-radio-wrapper');

        const input     = document.createElement('input');
        input.type      = 'radio';
        input.name      = `slide-indicator-${sectionEl.id}`; // unique per section
        input.value     = i;
        input.addEventListener('click', () => {
          sliderContainer.scrollTo({
            left: i * containerWidth,
            behavior: 'smooth'
          });
        });

        const dot       = document.createElement('span');
        dot.classList.add('top-radio-dot');

        label.appendChild(input);
        label.appendChild(dot);
        radioIndicatorContainer.appendChild(label);
      }
    }

    // Highlight the active dot
    function updateRadioIndicator() {
      const containerWidth = sliderContainer.clientWidth;
      const scrollLeft     = sliderContainer.scrollLeft;
      const activeIndex    = Math.round(scrollLeft / containerWidth);
      const radios         = radioIndicatorContainer.querySelectorAll('input[type="radio"]');

      radios.forEach((radio, idx) => {
        radio.checked = (idx === activeIndex);
      });
    }

    // Arrow click handlers
    function scrollByPage(direction) {
      const containerWidth = sliderContainer.clientWidth;
      const currentIndex   = Math.round(sliderContainer.scrollLeft / containerWidth);
      const maxIndex       = Math.ceil(sliderContainer.scrollWidth / containerWidth) - 1;
      let newIndex;

      if (direction === 'prev') {
        newIndex = currentIndex > 0 ? currentIndex - 1 : 0;
      } else {
        newIndex = currentIndex < maxIndex ? currentIndex + 1 : maxIndex;
      }

      sliderContainer.scrollTo({
        left: newIndex * containerWidth,
        behavior: 'smooth'
      });
    }

    // initial setup
    createDots();
    updateRadioIndicator();

    // re-create dots on resize
    window.addEventListener('resize', () => {
      createDots();
      updateRadioIndicator();
    });

    sliderContainer.addEventListener('scroll', updateRadioIndicator);
    prevButton.addEventListener('click', () => scrollByPage('prev'));
    nextButton.addEventListener('click', () => scrollByPage('next'));
  }

  /**
   * Only initialize when the section scrolls into view (optional speed boost)
   * @param {HTMLElement} sectionEl
   */
  function lazyInitSlider(sectionEl) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            initMainCategoriesSlider(entry.target);
            obs.disconnect();
          }
        });
      });
      io.observe(sectionEl);
    } else {
      initMainCategoriesSlider(sectionEl);
    }
  }

  // Wait until all HTML & CSS have been parsed
  window.addEventListener('load', () => {
    document
      .querySelectorAll('[id^="category-mini-slider-"]')
      .forEach(sectionEl => {
        lazyInitSlider(sectionEl);
      });
  });
})();
